import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";

import { useState } from "react";
import privateRequest from "../commonApi/CommonApi";
import { geocodeByAddress, getLatLng } from "react-google-places-autocomplete";

import Select from "react-select";

import Swal from "sweetalert2";
import MyCustomPlacesAutocomplete from "./Components/index";
import { Link, useNavigate } from "react-router-dom";

function CreateJob() {
  const [usersData, setUsersData] = useState();
  const [selectedGroup, setSelectedGroup] = useState();
  const navigate = useNavigate();
  const [mobile, setMobile] = useState();
  const [name, setName] = useState("");
  const [email, setEmail] = useState();
  const [combineData, setCombineData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [addresses, setAddresses] = useState([]);
  const [PCgroup, setPCgroup] = useState();
  const [slotData, setSlotData] = useState();
  const [slotsPreview, setSlotsPreview] = useState();
  const [otherCharges, setOtherCharges] = useState();
  const [services, setServices] = useState([]);
  const [concession, setConcession] = useState(0);
  const [selectedSlot, setselectedSlot] = useState();
  const [fullAdress, setFullAdress] = useState();
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [selectedItem, setselectedItem] = useState();
  const [house, setHouse] = useState();
  const [apartment, setApartment] = useState();
  const [landmark, setLandmark] = useState();
  const [items, setItems] = useState([]);
  const [selectedOption, setSelectedOption] = useState("Home");
  const [surg, setSurg] = useState(0);
  const [source, setSource] = useState("");
  const [itemRemoved, setItemRemoved] = useState(false);
  const [registered, setRegistered] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const [slotLoading, setSlotLoading] = useState(false);

  const [createValid, setCreateValid] = useState(false);
  const [couponCount, setCouponCount] = useState(0);

  const getCouponCount = async () => {
    try {
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      fetch("https://api.experts4u.in/api/v2/coupons/CouponCount", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log("result", result);
          setCouponCount(result?.TotalCount);
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.error("Error:", error);
    }
  }

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const updatedData = slotsPreview?.map((item) => {
    const updatedSlotTime = item.slotTime.replace(/(AM|PM)/, "");
    return { ...item, slotTime: updatedSlotTime };
  });

  const addRow = () => {
    setItems([
      ...items,
      {
        _id: items.length,
        packageTitle: "",
        Quantity: 1,
        Amount: 0,
        id: "",
        packageTotalTime: 0,
        packagetotalPrice: 0,
        packageRegulerPrice: 0,
        type: "",
        PCGroup: "",
        PCatId: "",
      },
    ]);
  };

  const removeItem = (id) => {
    setItems(items.filter((item) => item.value.value !== id));
    setItemRemoved(true);
  };

  console.log("itemsofcart", items);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get(`Service/CombineApis`);
      setCombineData(response?.data?.data);
      setPCgroup(response?.data?.data?.ParentGroup);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };
  const getUsersData = async () => {
    try {
      setLoading(true);

      const response = await privateRequest.get(
        `Address/GetAddressByMobileNo/` + mobile
      );

      setUsersData(response?.data.data);
      setMobile(response?.data?.data[0]?.mobileNo);
      setEmail(response?.data?.data[0]?.email);
      setName(response?.data?.data[0]?.name);
      setAddresses(response?.data?.data[0]?.address);
      setSelectedAddress(response?.data?.data[0]?.address[0]);
      console.log("response of users", response);

      setLoading(false);
    } catch (error) {
      setLoading(false);

      if (
        error.response.data.message ==
        "No users found for the provided mobile number"
      ) {
        setRegistered(false);
        setApartment("");
        setLandmark("");
        setHouse("");
        setFullAdress("");
      }
      // setApartment("");
      // setLandmark("");
      // setHouse("");
      // setFullAdress("");
      console.error(
        "Error fetching parent category groups:",
        error.response.data.message
      );
    }
  };

  useEffect(() => {
    if (mobile?.length == 10) {
      getUsersData();
    }

    if (mobile?.length < 10) {
      setEmail("");
      setName("");
      setAddresses("");
    }
  }, [mobile]);

  useEffect(() => {
    getAllDocumentData();
  }, []);

  let myApiKey = "AIzaSyCBRJgSZT50bFwgbOQHOWdi0giGUEdG3MY";

  let autocomplete;

  const componentForm1 = {
    street_number: "short_name",
    sublocality_level_1: "long_name",
    locality: "long_name",
    administrative_area_level_1: "long_name",
    country: "long_name",
    postal_code: "short_name",
  };

  useEffect(() => {
    initAutocomplete();
  }, []);

  const initAutocomplete = () => {
    autocomplete = new window.google.maps.places.Autocomplete(
      document.getElementById("search_location")
    );
    autocomplete.setComponentRestrictions({ country: ["in"] });
    autocomplete.addListener("place_changed", fillInAddress);
  };

  const fillInAddress = () => {
    const place = autocomplete.getPlace();

    for (let component in componentForm1) {
      document.getElementById(component).value = "";
    }

    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (componentForm1[addressType]) {
        const val = place.address_components[i][componentForm1[addressType]];
        document.getElementById(addressType).value = val;
      }
    }
  };

  const getSlots = async (date, PcatId) => {
    console.log(date, PcatId);
    try {
      setSlotLoading(true);
      let url = `AppoinmentSlot/SlotByParentId?date=${date}&PcatgroupId=${PcatId}`;
      const response = await privateRequest.get(url);
      setSlotData(response?.data?.data[0]);
      setSlotsPreview(response?.data?.data[0]?.slot);
      console.log("response?.data[0]?.slot", response?.data?.data[0]?.slot);
      setSlotLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const extractCommonPcatIds = (dataArray) => {
    const commonPcatIds = new Set();
    dataArray.forEach((item) => {
      if (item?.PCatId && item?.PCatId !== undefined) {
        commonPcatIds.add(item?.PCatId);
      }
    });
    return Array.from(commonPcatIds);
  };

  const getServices = async (selectedGroupId) => {
    try {
      let url = `Service/servicepackagebyPcgroup/` + selectedGroupId;
      const response = await privateRequest.get(url);

      setServices(response?.data?.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleGroupChange = (selectedOption) => {
    const selectedGroupId = selectedOption.value;
    const selectedGroupLabel = selectedOption.label;
    setSelectedGroup({
      label: selectedGroupLabel,
      value: selectedGroupId,
    });
    getServices(selectedGroupId);
  };

  const updateServiceName = (id, newName) => {
    const updatedItems = items.map((item, index) => {
      if (item._id === id) {
        return { ...item, ServiceName: newName };
      }
      return item;
    });

    setItems(updatedItems);
  };
  console.log("itemssss", items);
  const updateServiceId = (id, newName) => {
    console.log("data in update", id, newName);

    const updatedItems = items?.map((item, index) => {
      if (index === id) {
        // if (item.id === newName) {
        const Service = services?.find((option) => {
          const serviceId = option?._id;
          const variantId = option?.ServiceVarients?.[0]?._id;
          return serviceId === newName || variantId === newName;
        });

        if (!Service) {
          return item;
        }

        console.log("Service", Service);
        let serviceName = "Unknown Service";

        if (Service?.ServiceVarients?.[0]?.ServiceType) {
          const serviceType = Service.ServiceVarients[0].ServiceType;
          serviceName =
            serviceType?.Name !== "NA"
              ? `${Service?.ServiceName} - ${serviceType.Name}`
              : Service?.ChildCatIDs
              ? `${Service.ServiceName} - ${Service.ChildCatIDs.CCName}`
              : "Unknown Service";
        } else {
          console.log("servicename", Service);
        }

        const Amount = Service.packageTitle
          ? Service.payble
          : Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.salePrice;
        let packageNames = [];
        const time = Service?.serviceId?.reduce((sum, serviceObj) => {
          const serviceTime = parseInt(
            serviceObj?.service?.ServiceVarients[0]?.VarientDiscription[0]
              ?.ServiceTime,
            10
          );

          // const serviceTypee =
          //   serviceObj?.service?.ServiceVarients[0]?.ServiceType;
          let serviceTyped = serviceObj?.service?.ServiceVarients.filter(
            (item) => item?._id == serviceObj?.variant
          );
          let serviceTypee = serviceTyped[0]?.ServiceType;

          console.log("serviceObj?.variant", serviceTypee);
          console.log("foundedVariant", serviceTypee);

          let serviceNamee =
            serviceTypee?.Name !== "NA"
              ? `${serviceObj?.service.ServiceName} - ${serviceTypee?.Name}`
              : serviceObj?.service.ChildCatIDs
              ? `${serviceObj?.service.ServiceName} - ${serviceObj?.service.ChildCatIDs.CCName}`
              : "Unknown Service";

          packageNames.push(serviceNamee);

          return sum + (isNaN(serviceTime) ? 0 : serviceTime);
        }, 0);

        return {
          ...item,
          id: Service?.ServiceVarients?.[0]?._id || Service._id,
          value: {
            label: Service.packageTitle || serviceName,
            value: newName,
          },
          packagetotalPrice:
            parseInt(Service?.payble) ||
            parseInt(
              Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.salePrice
            ),
          packageRegulerPrice:
            parseInt(Service.RPrice) ||
            parseInt(
              Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.regularPrice
            ),
          packageTitle: Service.packageTitle || serviceName,
          packageTotalTime:
            time ||
            Service?.ServiceVarients?.[0]?.VarientDiscription[0]?.ServiceTime,
          type: Service.ServiceName ? "Service" : "Normal Package",
          PCGroup: selectedGroup?.value,
          Amount: Amount,
          PCatId: Service.packageTitle ? Service?.PcatId : Service?.PCatId?._id,
          packageName: packageNames || [],
        };
      }
      return item;
    });

    setItems(updatedItems);
  };

  const updateQuantity = (id, newQuantity) => {
    const updatedItems = items.map((item, index) => {
      if (index === id) {
        const Amount =
          parseFloat(item.packagetotalPrice) * parseInt(newQuantity);

        return { ...item, Quantity: newQuantity, Amount: Amount };
      }
      return item;
    });

    setItems(updatedItems);
  };

  let totalRegulerPrice = 0;
  let totalSalePrice = 0;
  let totalTime = 0;
  items?.forEach((item) => {
    totalRegulerPrice +=
      parseFloat(item.packageRegulerPrice) * parseInt(item.Quantity);

    totalSalePrice +=
      parseFloat(item.packagetotalPrice) * parseInt(item.Quantity);
    totalTime += parseFloat(item?.packageTotalTime) * parseInt(item.Quantity);
  });

  let totalDiscount = totalRegulerPrice - totalSalePrice || 0;

  let totalCharges = 0;

  let totalSumofOtherCharges = otherCharges
    ? otherCharges?.reduce(
        (accumulator, currentCharge) =>
          accumulator + parseFloat(currentCharge.price),
        0
      )
    : 0;

  let d = concession > 0 ? parseFloat(concession) : 0;
  let totalAmount =
    surg + totalSalePrice + totalCharges + totalSumofOtherCharges - d;

  function removeIdFromItems(items) {
    return items.map((item) => {
      const { _id, ...rest } = item;
      return rest;
    });
  }

  const itemsWithoutIdd = removeIdFromItems(items);

  const removeBlankItems = (items) => {
    return items.filter((item) => item.id && item.packageTitle);
  };

  const itemsWithoutId = removeBlankItems(itemsWithoutIdd);

  const getHighestValueCharges = (data) => {
    const chargesMap = {};

    data.forEach((charge) => {
      const { ChargesName, ChargesValue } = charge;
      if (
        !chargesMap[ChargesName] ||
        chargesMap[ChargesName].ChargesValue < ChargesValue
      ) {
        chargesMap[ChargesName] = charge;
      }
    });

    return Object.values(chargesMap);
  };

  const getOtherCharges = async () => {
    try {
      let url = `OtherCharges/OtherChargeByPId`;
      const response = await privateRequest.post(url, {
        Pcat: commonPcatIds,
      });
      let a = getHighestValueCharges(response?.data?.Data);

      let chargesInfo = a?.map((charge) => ({
        charge: charge.ChargesName,
        price: charge.ChargesValue,
      }));

      console.log("otherchargesfilterreddd", a);

      setOtherCharges(chargesInfo);
      setItemRemoved(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (selectedAddress) {
      setFullAdress(selectedAddress?.FullAddress);
      setApartment(selectedAddress?.buildingName);
      setHouse(selectedAddress?.houseOrFlatNo);
      setLandmark(selectedAddress?.landmark);
      setSelectedOption(selectedAddress?.SaveAs);
    }
  }, [selectedAddress]);

  const requestBody = {
    slotDate: slotData?.slotDate && slotData?.slotDate,
    slotTime: selectedSlot,
    name: name,
    clientAddressId: selectedAddress?._id,
    TServiceTiming: totalTime,
    jobsSource: source,
    RPrice: totalRegulerPrice,
    email: email,
    mobileNo: mobile,
    SPrice: totalSalePrice,
    concession: concession ? concession : 0,
    surgeCharges: surg,
    cancelCharges: "0",
    payableCharges: totalAmount,
    cart: itemsWithoutId,
    payment_Mode: "",
    Status: "pending",
    houseOrFlatNo: house || selectedAddress?.houseOrFlatNo,
    buildingName: apartment || selectedAddress?.buildingName,
    landmark: landmark || selectedAddress?.landmark,
    FullAddress: fullAdress || selectedAddress?.FullAddress,
    location: {
      longitude: longitude || selectedAddress?.location?.longitude,
      latitude: latitude || selectedAddress?.location?.latitude,
    },
    SaveAs: selectedOption,
    otherCharges: otherCharges,
  };
  const commonPcatIds = extractCommonPcatIds(itemsWithoutId);

  console.log("itemsWithoutId", itemsWithoutId);
  console.log("itemsWithoutId");

  console.log("selectedAddress", selectedAddress);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedAddress) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please select or add a address",
      });
      return;
    }

    try {
      setLoading(true);
      const response = await privateRequest.post("jobs/Addjobs", requestBody);
      navigate("/todaysjob");
      setLoading(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Order Created successfully!",
      });
    } catch (error) {
      if (error.response?.data) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.response?.data?.message,
        });
        setLoading(false);
      }
      console.error("Error creating Order:", error);
    }
  };

  const deleteChild = async (obj, e) => {
    e.preventDefault();
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `Address/DeleteAddressByMobile`,
          {
            data: obj,
          }
        );

        if (response) {
          getUsersData();
        }

        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  const handleAddress = (e) => {
    geocodeByAddress(fullAdress)
      .then((results) => getLatLng(results[0]))
      .then(({ lat, lng }) => {
        console.log("Successfully got latitude and longitude", { lat, lng });
        setLatitude(lat);
        setLongitude(lng);
      })
      .catch((error) => {
        console.error("Error geocoding address:", error);
        // Handle errors here, such as displaying an error message to the user
      });
  };
  const handleOnchage = (place) => {
    setFullAdress(place?.description);
  };

  useEffect(() => {
    if (fullAdress) {
      handleAddress();
    }
  }, [fullAdress]);

  useEffect(() => {
    if (items) {
      getOtherCharges();
      setItemRemoved(true);
    }
  }, [items]);

  const validateAddress = () => {
    if (!fullAdress) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter a valid location",
      });
      return false;
    }
    if (!house) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter House or Flat Number",
      });
      return false;
    }

    if (!apartment) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter Building Name",
      });
      return false;
    }

    if (!mobile) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please enter Mobile Number",
      });
      return false;
    }

    if (!selectedOption) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Please select an option for Save As",
      });
      return false;
    }

    return true;
  };
  console.log("selected address", selectedAddress);

  const EditUserAddress = async () => {
    console.log("address ko edit karne aya");
    try {
      if (!validateAddress()) {
        return;
      }

      let adres = {
        houseOrFlatNo: house,
        addressId: selectedItem?._id,
        buildingName: apartment,
        FullAddress: fullAdress,
        landmark: landmark,
        mobileNo: mobile,
        location: {
          longitude: longitude,
          latitude: latitude,
        },
        SaveAs: selectedOption,
      };
      let adress = {
        houseOrFlatNo: house,
        buildingName: apartment,
        FullAddress: fullAdress,
        landmark: landmark,
        mobileNo: mobile,
        location: {
          longitude: longitude,
          latitude: latitude,
        },
        SaveAs: selectedOption,
      };

      if (addresses.length > 0) {
        if (selectedItem) {
          let response = await privateRequest.put(
            "Address/UpdateAddressByMobile",
            adres
          );
          if (response) {
            setCreateValid(true);
            getUsersData();
          }
          Swal.fire("Updated!", "Your address has been updated.", "success");
        } else {
          let response = await privateRequest.post(
            "Address/CreateAddressWithMobile",
            adress
          );
          if (response) {
            setCreateValid(true);
            getUsersData();
          }
          Swal.fire("Saved!", "Your address has been saved.", "success");
        }
      } else if (addresses.length < 1 && usersData[0]?.mobileNo == mobile) {
        let response = await privateRequest.post(
          "Address/CreateAddressWithMobile",
          adress
        );
        if (response) {
          setCreateValid(true);
          getUsersData();
        }
        Swal.fire("Saved!", "Your address has been saved.", "success");
      } else {
        if (validateAddress()) {
          setCreateValid(true);
          // adress.push(adress);
        }
        Swal.fire(
          "Saved!",
          "Your address has been saved to local storage.",
          "success"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error!", "Failed to save address.", "error");
    }
  };

  const handlePriceChange = (index, newPrice) => {
    const updatedCharges = otherCharges.map((item, i) =>
      i === index ? { ...item, price: newPrice } : item
    );
    setOtherCharges(updatedCharges);
  };

  useEffect(() => {
    if (PCgroup) {
      let a = new Date().toISOString().split("T")[0];
      getSlots(a, PCgroup[0]?._id);
    }
  }, [PCgroup]);

  console.log("addresfeilds", apartment, house, fullAdress, landmark);

  return (
    <div className="app has-fullwidth">
      <main className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">New Job</span>
                    </p>
                    <Link
                      to={"/todaysjob"}
                      className="ml-auto btn btn-primary btn-sm"
                    >
                      <i className="fa fa-list"></i> All Jobs
                    </Link>
                  </div>
                </header>

                <div className="page-section">
                  <form id="new_job" className="needs-validation" novalidate="">
                    <div className="row mb-3 card-pad">
                      <div className="col-lg-6">
                        <div className="card" style={{ height: "100%" }}>
                          <div className="card-header">
                            <h4 className="card-title mb-0">
                              Customer Details
                            </h4>
                          </div>
                          <div className="card-body row pb-0 mb-0">
                            <div className="form-group col-lg-6">
                              <label>Mobile No</label>
                              <div className="has-spinner">
                                <div
                                  className={
                                    loading == false
                                      ? "spinner-border spinner-border-sm text-primary"
                                      : "spinner-border spinner-border-sm text-primary show"
                                  }
                                  role="status"
                                >
                                  <span className="sr-only">Loading...</span>
                                </div>

                                <input
                                  value={mobile}
                                  onChange={(e) => {
                                    setMobile(e.target.value);
                                  }}
                                  type="text"
                                  className="form-control"
                                  placeholder="Mobile No"
                                  id="cx_mobile"
                                  name="cx_mobile"
                                  required
                                  maxLength={10}
                                />
                              </div>
                            </div>
                            <div className="form-group col-lg-6">
                              <label>Name</label>
                              <input
                                value={name}
                                onChange={(e) => {
                                  setName(e.target.value);
                                }}
                                type="text"
                                className="form-control"
                                placeholder="Name"
                                id="cx_name"
                                name="cx_name"
                                required
                              />
                            </div>
                            <div className="form-group col-lg-6">
                              <label>Email</label>
                              <input
                                value={email}
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                }}
                                type="email"
                                className="form-control"
                                placeholder="Email ID"
                                id="cx_email"
                                name="cx_email"
                                required
                              />
                            </div>
                            <div className="form-group col-lg-6">
                              <label>Parent Category Group</label>
                              <Select
                                isClearable
                                options={PCgroup?.map((group) => ({
                                  value: group._id,
                                  label: group.PCGName,
                                }))}
                                onChange={handleGroupChange}
                                value={selectedGroup}
                                isMulti={false}
                              />
                            </div>

                            <div className="form-group col-lg-6">
                              <label>Select Source</label>
                              <select
                                className="form-control"
                                value={source}
                                name="job_src"
                                id="job_src"
                                onChange={(e) => {
                                  setSource(e.target.value);
                                }}
                              >
                                <option value="">Select Source</option>
                                <option value={"Whats app"}>Whats app</option>
                                <option value={"Facebook"}>Facebook</option>
                                <option value={"Website"}>Website</option>
                                <option value={"Reffer"}>Reffer</option>
                                <option value={"GMB"}>GMB</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="card" style={{ height: "100%" }}>
                          <div className="card-header d-flex justify-content-between align-items-center">
                            <h4 className="card-title mb-0">Address Details</h4>
                            <a
                              href="javascript:void(0)"
                              data-toggle="modal"
                              data-target="#exampleModalCenter"
                              onClick={() => {
                                setApartment("");
                                setLandmark("");
                                setHouse("");
                                setFullAdress("");
                              }}
                            >
                              <i className="fa fa-plus mr-2"></i>Add Address
                            </a>
                          </div>
                          <div
                            className="card-body py-2"
                            style={{ height: "200px", overflow: "auto" }}
                          >
                            <div className="row">
                              <div className="col-lg-12">
                                {addresses.length > 0 &&
                                  addresses?.map((item, index) => {
                                    return (
                                      <div className="form-group">
                                        <div className="custom-control custom-radio d-flex justify-content-between align-items-center ">
                                          <div>
                                            <input
                                              type="radio"
                                              className="custom-control-input"
                                              name="rdGroup2"
                                              checked={
                                                selectedAddress == item
                                                  ? true
                                                  : false
                                              }
                                              id={index}
                                              onChange={() =>
                                                setSelectedAddress(item)
                                              }
                                            />
                                            <label
                                              className="custom-control-label"
                                              htmlFor={index}
                                            >
                                              <strong className="text-capitalize">
                                                {item?.SaveAs}
                                              </strong>
                                              <p className="mb-0">
                                                {item?.houseOrFlatNo},{" "}
                                                {item?.buildingName},{" "}
                                                {item?.landmark
                                                  ? item?.landmark
                                                  : ""}
                                              </p>
                                              <p>{item?.FullAddress}</p>
                                            </label>
                                          </div>
                                          <div className="btn-group mr-3">
                                            <button
                                              type="button"
                                              href="javascript:void(0)"
                                              data-toggle="modal"
                                              data-target="#exampleModalCenter"
                                              className="btn btn-primary btn-sm rounded-0"
                                              onClick={() => {
                                                setApartment(
                                                  item?.buildingName
                                                );
                                                setFullAdress(
                                                  item?.FullAddress
                                                );
                                                setselectedItem(item);
                                                setHouse(item?.houseOrFlatNo);
                                                setLandmark(
                                                  item?.landmark
                                                    ? item?.landmark
                                                    : " "
                                                );
                                              }}
                                            >
                                              <i className="fa fa-edit"></i>
                                            </button>
                                            <button
                                              onClick={(e) => {
                                                let obj = {
                                                  mobileNo: mobile,
                                                  addressId: item?._id,
                                                };
                                                if (addresses.length === 1) {
                                                  if (registered === false) {
                                                    Swal.fire({
                                                      title: "Are you sure?",
                                                      text: "You will not be able to recover this address!",
                                                      icon: "warning",
                                                      showCancelButton: true,
                                                      confirmButtonColor:
                                                        "#DD6B55",
                                                      confirmButtonText:
                                                        "Yes, delete it!",
                                                      cancelButtonText:
                                                        "No, cancel",
                                                      closeOnConfirm: true,
                                                      closeOnCancel: true,
                                                    }).then((result) => {
                                                      if (result.isConfirmed) {
                                                        setAddresses([]);
                                                        Swal.fire(
                                                          "Deleted!",
                                                          "Your address has been deleted.",
                                                          "success"
                                                        );
                                                      }
                                                    });
                                                  } else {
                                                    Swal.fire({
                                                      icon: "error",
                                                      title: "Error!",
                                                      text: "Can't delete all addresses",
                                                    });
                                                  }
                                                } else {
                                                  deleteChild(obj, e);
                                                }

                                                // if (addresses.length == 1) {
                                                //   if (registered == false) {
                                                //     const result =  Swal.fire({
                                                //       title: "Are you sure?",
                                                //       text: "You will not be able to recover this address!",
                                                //       icon: "warning",
                                                //       showCancelButton: true,
                                                //       confirmButtonColor:
                                                //         "#DD6B55",
                                                //       confirmButtonText:
                                                //         "Yes, delete it!",
                                                //       cancelButtonText:
                                                //         "No, cancel",
                                                //       closeOnConfirm: true,
                                                //       closeOnCancel: true,
                                                //     });
                                                //     if (result.isConfirmed) {
                                                //       console.log("confirmed");
                                                //       // setAddresses([]);
                                                //       Swal.fire(
                                                //         "Deleted!",
                                                //         "Your address has been deleted.",
                                                //         "success"
                                                //       );
                                                //     }
                                                //   }
                                                //   // Swal.fire({
                                                //   //   icon: "error",
                                                //   //   title: "Error!",

                                                //   //   text: "can't delete all addresses",
                                                //   // });
                                                // } else {
                                                //   deleteChild(obj, e);
                                                // }
                                              }}
                                              type="button"
                                              className="btn btn-danger btn-sm rounded-0"
                                            >
                                              <i className="fa fa-trash"></i>
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card card-1">
                      <div className="card-body border-top border-bottom ">
                        <h4 className="card-title mb-0">Cart Details</h4>
                      </div>
                      <div className="card-body pb-0 mb-0 mant-card">
                        <div className="row detel-card">
                          <div className="col-lg-12 tab-main">
                            <table
                              id="itemTable"
                              className="table table-bordered tabalres"
                            >
                              <thead>
                                <tr>
                                  <th>Service/Package</th>
                                  <th
                                    style={{ width: "10%" }}
                                    className="text-right"
                                  >
                                    Quantity
                                  </th>

                                  <th
                                    style={{ width: "15%" }}
                                    className="text-right"
                                  >
                                    Rate
                                  </th>

                                  <th
                                    style={{ width: "15%" }}
                                    className="text-right"
                                  >
                                    Amount
                                  </th>
                                  <th style={{ width: "5%" }}></th>
                                </tr>
                              </thead>
                              <tbody>
                                {items.map((item, index) => (
                                  <tr key={index}>
                                    <td className="input-res">
                                      <Select
                                        isClearable
                                        label={
                                          item
                                            ? item.ServiceName ||
                                              "Unknown Service"
                                            : "Unknown Item"
                                        }
                                        options={
                                          services
                                            ? services.map((group) => {
                                                let serviceName =
                                                  "Unknown Service";

                                                if (
                                                  group.ServiceVarients &&
                                                  group.ServiceVarients[0] &&
                                                  group.ServiceVarients[0]
                                                    .ServiceType
                                                ) {
                                                  const serviceType =
                                                    group.ServiceVarients[0]
                                                      .ServiceType;
                                                  serviceName =
                                                    serviceType.Name !== "NA"
                                                      ? `${group.ServiceName} - ${serviceType.Name}`
                                                      : group.ChildCatIDs
                                                      ? `${group.ServiceName} - ${group.ChildCatIDs.CCName}`
                                                      : "Unknown Service";
                                                }
                                                let vall =
                                                  (group.ServiceVarients &&
                                                    group.ServiceVarients[0] &&
                                                    group.ServiceVarients[0]
                                                      ._id) ||
                                                  group?._id;

                                                return {
                                                  value: vall,
                                                  label:
                                                    group.packageTitle ||
                                                    serviceName,
                                                };
                                              })
                                            : []
                                        }
                                        onChange={(e) => {
                                          console.log("e", e);
                                          updateServiceName(index, e.value);
                                          updateServiceId(index, e.value);
                                        }}
                                        value={item.value}
                                        isMulti={false}
                                      />
                                    </td>
                                    <td>
                                      <input
                                        min="0"
                                        type="number"
                                        className="form-control form-control-sm border-0 shadow-none text-right serviceQty"
                                        value={item?.Quantity}
                                        name="service_item[90501][s_qty]"
                                        onChange={(e) => {
                                          const newValue = Math.max(
                                            0,
                                            parseInt(e.target.value)
                                          );
                                          updateQuantity(index, newValue);
                                        }}
                                      />
                                    </td>

                                    <td>
                                      <input
                                        type="number"
                                        readOnly
                                        className="form-control form-control-sm border-0 rat-res shadow-none text-right txt_rate"
                                        value={item?.packagetotalPrice}
                                        name="service_item[90501][s_rate]"
                                      />
                                    </td>

                                    <td align="right">
                                      <input
                                        type="number"
                                        readOnly
                                        value={item?.Amount}
                                        className="form-control form-control-sm border-0 shadow-none text-right item_qty_amount_total amt_will_add"
                                      />
                                    </td>
                                    <td className="text-center">
                                      <button
                                        onClick={() => {
                                          if (item?.value?.value) {
                                            removeItem(item?.value.value);
                                          } else {
                                            Swal.fire({
                                              icon: "error",
                                              title: "Error!",
                                              text: "Please select a service before its remove",
                                            });
                                          }
                                        }}
                                        type="button"
                                        className="btn btnDelete"
                                      >
                                        <i className="fa fa-times-circle text-danger "></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="col-lg-6">
                            <div className="btn-group">
                              <button
                                onClick={() => {
                                  addRow();
                                }}
                                type="button"
                                className="btn btn-primary insert_service_Line btn-sm"
                              >
                                <i className="fa fa-plus-circle text-white"></i>{" "}
                                Add Another Item
                              </button>
                            </div>

                            <div className="card mt-3">
                              <div className="card-header">
                                <h4 className="card-title mb-0">
                                  Slot Details
                                </h4>
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  <div className="col-12 slotDates">
                                    <input
                                      type="date"
                                      id="dateFilter"
                                      className="form-control"
                                      value={selectedDate}
                                      onChange={(e) => {
                                        setSelectedDate(e.target.value);

                                        if (selectedGroup?.value) {
                                          getSlots(
                                            e.target.value,
                                            selectedGroup?.value
                                          );
                                        } else {
                                          Swal.fire({
                                            icon: "error",
                                            title: "Error!",
                                            // text: "Error creating Order",
                                            text: "Please select parent category group",
                                          });
                                        }
                                      }}
                                    />
                                  </div>
                                  <div className="col-lg-12 mt-4 ">
                                    {slotLoading ? (
                                      <div className="text-center">
                                        <div
                                          class="spinner-border text-primary loader p-3 my-4 "
                                          role="status"
                                        >
                                          <span class="sr-only">
                                            Loading...
                                          </span>
                                        </div>
                                      </div>
                                    ) : (
                                      <>
                                        {slotsPreview &&
                                          updatedData?.map((item, index) => {
                                            let styles = {
                                              backgroundColor: "gray",
                                              color: "#fff",
                                            };
                                            return (
                                              <div
                                                key={index}
                                                className="visual-picker visual-picker-sm has-peek mr-2 mb-3"
                                              >
                                                <input
                                                  type="radio"
                                                  id={index + "time"}
                                                  className="slot_input"
                                                  checked={
                                                    selectedSlot ===
                                                    item.slotTime
                                                  }
                                                  required=""
                                                  value={item.slotTime}
                                                  name="time_slot[]"
                                                  onChange={(e) => {
                                                    setselectedSlot(
                                                      e.target.value
                                                    );
                                                    setSurg(
                                                      parseFloat(
                                                        item?.surgCharges
                                                      )
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="visual-picker-figure"
                                                  htmlFor={index + "time"}
                                                >
                                                  <small
                                                    className="visual-picker-content slot_span"
                                                    style={
                                                      item?.statusButton ==
                                                        false &&
                                                      selectedSlot !=
                                                        item.slotTime
                                                        ? styles
                                                        : null
                                                    }
                                                  >
                                                    {item.slotTime}
                                                  </small>
                                                  {item.surgCharges !== 0 && (
                                                    <small className="badge badge-warning surgeCharge_span">
                                                      {item.surgCharges}
                                                    </small>
                                                  )}
                                                </label>
                                                <small
                                                  style={{
                                                    position: "absolute",
                                                    top: "21px",
                                                    background: "yellow",
                                                    padding: "0px 13px",
                                                    right: "25%",
                                                    borderRadius: "22px",
                                                  }}
                                                ></small>
                                              </div>
                                            );
                                          })}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <table className="table invoiceTable">
                              <tbody>
                                <tr>
                                  <td>
                                    <strong>Regular / Sale Price</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      type="text"
                                      readOnly
                                      className="form-control text-right mr-2"
                                      id="regular_price_spn"
                                      value={totalRegulerPrice}
                                      name="regular_price_spn"
                                    />
                                    <input
                                      type="text"
                                      readOnly
                                      id="sale_price_spn"
                                      className="form-control text-right"
                                      value={totalSalePrice}
                                      name="sale_price_spn"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Discount</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <label
                                      className="form-control text-right pr-4"
                                      id="total_discount"
                                    >
                                      {totalDiscount}
                                    </label>
                                  </td>
                                </tr>

                                <tr>
                                  <td>
                                    <strong>Convenience</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      name="convenience"
                                      onblur="calculation()"
                                      type="number"
                                      id="convenience"
                                      value="0"
                                      className="form-control text-right amt_will_add"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Surge Amount</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      name="slug_amt"
                                      type="number"
                                      id="slug_amt"
                                      value={surg}
                                      onChange={(e) => {
                                        let value = parseInt(
                                          e.target.value != 0
                                            ? e.target.value
                                            : 0
                                        );
                                        setSurg(value);
                                      }}
                                      className="form-control text-right amt_will_add"
                                    />
                                  </td>
                                </tr>

                                {otherCharges &&
                                  otherCharges.map((item, index) => {
                                    return (
                                      <tr>
                                        <td>
                                          <strong>{item?.charge}</strong>
                                        </td>
                                        <td className="text-right d-flex">
                                          <span className="mr-2">₹</span>
                                          <input
                                            name="sef_hyg_kit"
                                            onChange={(e) =>
                                              handlePriceChange(
                                                index,
                                                Number(e.target.value)
                                              )
                                            }
                                            type="number"
                                            id="sef_hyg_kit"
                                            value={item?.price}
                                            className="form-control text-right amt_will_add"
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                <tr>
                                  <td>
                                    <strong>Concession</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      // onblur="calculation()"
                                      name="concession"
                                      type="number"
                                      id="concession"
                                      value={concession}
                                      onChange={(e) => {
                                        setConcession(e.target.value);
                                      }}
                                      className="form-control text-right amt_will_minus"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <strong>Total</strong>
                                  </td>
                                  <td className="text-right d-flex">
                                    <span className="mr-2">₹</span>
                                    <input
                                      type="number"
                                      readOnly
                                      className="form-control text-right"
                                      id="payble_amount"
                                      name="payble_amount"
                                      value={totalAmount}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <input
                        type="hidden"
                        value="new_job"
                        name="action"
                        id="action"
                      />
                      <div className="card-body border-top">
                        <button
                          onClick={handleSubmit}
                          type="button"
                          className="btn btn-primary"
                        >
                          {loading ? (
                            <div
                              class="spinner-border text-light loader"
                              role="status"
                            >
                              <span class="sr-only">Loading...</span>
                            </div>
                          ) : (
                            <span> Create Job</span>
                          )}
                        </button>
                        <div className="coupon-count">
                          <span>Coupon Count: {couponCount}</span>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <div
        className="modal fade"
        id="exampleModalCenter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content popup-res">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Add Address
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setApartment("");
                  setLandmark("");
                  setHouse("");
                  setFullAdress("");
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group inti">
                    <MyCustomPlacesAutocomplete
                      inputValuee={fullAdress?.length > 0 ? false : true}
                      handleOnChange={handleOnchage}
                      apiKey={myApiKey}
                      inputValue={fullAdress}
                      setInputValue={setFullAdress}
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group ">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="House/Flat No"
                      value={house}
                      onChange={(e) => {
                        setHouse(e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <input
                      value={apartment}
                      onChange={(e) => {
                        setApartment(e.target.value);
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Appartment/Society/Building Name"
                    />
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Landmark"
                      value={landmark}
                      onChange={(e) => {
                        setLandmark(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <label>Save As</label>
                  <br />
                  <div className="visual-picker visual-picker-sm has-peek mr-2">
                    <input
                      onChange={handleOptionChange}
                      type="radio"
                      id="vpr01"
                      name="vprSM"
                      value="Home"
                      checked={selectedOption === "Home"}
                    />
                    <label
                      className="visual-picker-figure"
                      style={{ width: "100px", height: "40px" }}
                      htmlFor="vpr01"
                    >
                      <span className="visual-picker-content">Home</span>
                    </label>
                  </div>

                  <div className="visual-picker visual-picker-sm has-peek ">
                    <input
                      onChange={handleOptionChange}
                      type="radio"
                      id="vpr02"
                      name="vprSM"
                      value="Office"
                      checked={selectedOption === "Office"}
                    />
                    <label
                      className="visual-picker-figure"
                      style={{ width: "100px", height: "40px" }}
                      htmlFor="vpr02"
                    >
                      <span className="visual-picker-content">Office</span>
                    </label>
                  </div>
                </div>
                <div className="col-lg-12 text-right mb-3">
                  <button
                    onClick={() => {
                      setTimeout(() => {
                        setCreateValid(true);
                      }, 0);

                      const newAddress = {
                        houseOrFlatNo: house,
                        buildingName: apartment,
                        FullAddress: fullAdress,
                        landmark: landmark,
                        mobileNo: mobile,
                        location: {
                          longitude: longitude,
                          latitude: latitude,
                        },
                        SaveAs: selectedOption,
                        ...(selectedItem && { addressId: selectedItem._id }),
                      };

                      if (addresses.length > 0) {
                        if (!registered) {
                          setCreateValid(true);

                          setAddresses([newAddress]);
                          setSelectedAddress(newAddress);
                        } else {
                          setCreateValid(true);
                          EditUserAddress();
                        }
                      } else {
                        if (!validateAddress()) {
                          setCreateValid(false);
                          return;
                        } else {
                          setCreateValid(true);
                          setAddresses([...addresses, newAddress]);
                          setSelectedAddress(newAddress);
                        }
                      }
                    }}
                    type="button"
                    className="btn btn-primary"
                    {...(createValid && { "data-dismiss": "modal" })}
                    aria-label="Close"
                  >
                    Save Address
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateJob;
